<template>
  <div class="holdRuleGroupView">
    <b-card>
        <b-row>
            <b-col cols="12">
                <b-card-title>Voorwaarden binnen deze groep:</b-card-title>
            </b-col>
        </b-row>

        <b-row>
            <b-col cols="12">
                <GroupRules :rules="groupData.hold_rules" />
            </b-col>
        </b-row>

        <b-row>
            <b-col cols="12">
                <b-button-group>
                    <b-button v-if="hasPermission('holdrules.edit')" @click="editGroup" class="bg-midnight-bloom text-white">
                        <i class="far fa-pencil mr-1" />
                        Groep bewerken
                    </b-button>
                </b-button-group>
            </b-col>
        </b-row>
    </b-card>
  </div>
</template>

<style>
.holdRuleGroupView {
  margin-bottom: 1.5rem;
}
</style>

<script>
import GroupRules from "./components/GroupRules.vue";

export default {
  name: "HoldRuleGroupView",

  props: {
    groupData: {
      type: Object,
      required: true,
    },
  },

  methods: {
    editGroup() {
      this.$router.push({ name: 'holdRuleGroupEdit', params: this.$route.params });
    },
  },

  components: {
    GroupRules
  },
};
</script>
